const header = {
  Title: "Emerson Ecologics",
  Cart: "Cart ({{numberOfCartItems}})",
  Search: "Search",
  Close: "Close",
  OpenHamburger: "Open hamburger menu",
  OpenSearch: "Open search menu",
  Login: "Login",
  Logout: "Log out",
  Signup: "Sign up",
  Signin: "Sign in",
  Logo: "Emerson Ecologics logo",
  Shop: {
    Header: "Shop",
    New: "New",
    Specials: "Specials",
    CouponCode: "Coupon code",
    ReorderProducts: "Reorder products",
  },
  Brands: {
    Header: "Brands",
    FeaturedBrands: "Featured Brands",
    PopularBrands: "Popular Brands",
    SeeAll: "See all brands",
  },
  Orders: {
    RecentOrders: "Recent Orders",
  },
  Quality: {
    Header: "Quality",
    About: "About the EQP",
    EQPPartners: "EQP partners",
    QualityPartners: "Shop quality partners",
  },
  Education: {
    Header: "Education",
    Blog: "Blog",
    FSAcademy: "Fullscript academy",
    PracticeResources: "Practice resources",
  },
  Account: {
    AccountSettings: "Account settings",
    MyOrders: "My orders",
    Support: "Support",
    WritePlans: "Fullscript - Write plans",
  },
  PrivacyPolicy: "Privacy policy",
  TermsOfSale: "Terms of sale",
  QuickOrder: {
    Header: "Quick Order",
  },
} as const;

export { header };
